module.exports = __webpack_public_path__ + "static/media/lease2_img3.5a80a65e.jpg";